module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_8017.1eee9d5a.png";